import { render, staticRenderFns } from "./CarouselEventDetails.vue?vue&type=template&id=26964dd5&"
import script from "./CarouselEventDetails.vue?vue&type=script&lang=js&"
export * from "./CarouselEventDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsImageDefault: require('/var/web/bet777.es/components/elements/image_default.vue').default})
